/**
 * YUMI KIDS — Wishlist Slider Drawer Manager
 * Integrates Shopify wishlist localStorage with sliding offcanvas drawer
 */

(function () {
  'use strict';

  var LOCAL_STORAGE_KEY = 'shopify-wishlist';
  var DELIMITER = ',';
  var productCache = {};

  // 1. Get & Set Wishlist from LocalStorage
  function getWishlistHandles() {
    try {
      var raw = localStorage.getItem(LOCAL_STORAGE_KEY);
      if (!raw) return [];
      return raw.split(DELIMITER).map(function (h) { return h.trim(); }).filter(Boolean);
    } catch (e) {
      return [];
    }
  }

  function setWishlistHandles(handles) {
    try {
      if (handles && handles.length > 0) {
        localStorage.setItem(LOCAL_STORAGE_KEY, handles.join(DELIMITER));
      } else {
        localStorage.removeItem(LOCAL_STORAGE_KEY);
      }
    } catch (e) {}
  }

  // 1b. Cache and Persist Fallback Product Metadata (for Hampers and Dynamic Cards)
  function saveProductMeta(handle, meta) {
    if (!handle || !meta) return;
    try {
      localStorage.setItem('shopify-wishlist-meta-' + handle, JSON.stringify(meta));
      productCache[handle] = meta;
    } catch (e) {}
  }

  function getProductMeta(handle) {
    if (!handle) return null;
    try {
      var raw = localStorage.getItem('shopify-wishlist-meta-' + handle);
      if (raw) return JSON.parse(raw);
    } catch (e) {}
    return null;
  }

  // 2. Format Money
  function formatMoney(cents) {
    if (typeof cents === 'string' && (cents.indexOf('₹') !== -1 || cents.indexOf('Rs.') !== -1 || cents.indexOf('$') !== -1)) {
      return cents;
    }
    if (typeof cents !== 'number') cents = parseInt(cents, 10) || 0;
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try {
        return window.Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : 'Rs. {{amount}}');
      } catch (e) {}
    }
    var amount = Math.round(cents / 100);
    return '₹' + amount.toLocaleString('en-IN');
  }

  // 3. Inject Wishlist Drawer Markup
  function ensureDrawer() {
    if (document.getElementById('wishlistDrawer')) return;

    var html = `
      <div class="wishlist-backdrop" id="wishlistBackdrop"></div>
      <aside class="wishlist-drawer" id="wishlistDrawer" role="dialog" aria-modal="true" aria-label="Wishlist Drawer">
        <div class="wishlist-drawer__header">
          <h3 class="wishlist-drawer__title">
            <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22" style="color:#E74C3C"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
            <span>Your Saved Wishlist</span>
            <span class="wishlist-drawer__count" id="drawerWishlistCount">(0)</span>
          </h3>
          <button class="wishlist-drawer__close" id="wishlistClose" aria-label="Close wishlist">✕</button>
        </div>
        <div class="wishlist-drawer__items" id="wishlistItemsContainer">
          <div class="wishlist-drawer__loading">
            <div class="wishlist-spinner"></div>
          </div>
        </div>
        <div class="wishlist-drawer__footer" id="wishlistFooter" style="display:none">
          <button type="button" class="btn-wishlist-continue" id="wishlistContinueShopping">CONTINUE SHOPPING 🛍️</button>
        </div>
      </aside>

      <div class="wishlist-toast" id="wishlistToast">
        <span id="wishlistToastMsg"></span>
      </div>
    `;

    document.body.insertAdjacentHTML('beforeend', html);

    document.getElementById('wishlistClose').addEventListener('click', closeDrawer);
    document.getElementById('wishlistBackdrop').addEventListener('click', closeDrawer);
    document.getElementById('wishlistContinueShopping').addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });
  }

  // 4. Open / Close Drawer
  function openDrawer() {
    ensureDrawer();
    renderDrawer();
    var drawer = document.getElementById('wishlistDrawer');
    var backdrop = document.getElementById('wishlistBackdrop');
    if (drawer) drawer.classList.add('active');
    if (backdrop) backdrop.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    var drawer = document.getElementById('wishlistDrawer');
    var backdrop = document.getElementById('wishlistBackdrop');
    if (drawer) drawer.classList.remove('active');
    if (backdrop) backdrop.classList.remove('active');
    document.body.style.overflow = '';
  }

  // 5. Toast Notification
  function showToast(msg) {
    ensureDrawer();
    var toast = document.getElementById('wishlistToast');
    var msgEl = document.getElementById('wishlistToastMsg');
    if (!toast || !msgEl) return;
    msgEl.textContent = msg;
    toast.classList.add('show');
    clearTimeout(toast._timer);
    toast._timer = setTimeout(function () {
      toast.classList.remove('show');
    }, 2800);
  }

  // 6. Fetch Product Details
  function fetchProduct(handle) {
    if (productCache[handle]) {
      return Promise.resolve(productCache[handle]);
    }
    var savedMeta = getProductMeta(handle);
    return fetch('/products/' + handle + '.js')
      .then(function (res) {
        if (!res.ok) throw new Error('Product not found');
        return res.json();
      })
      .then(function (prod) {
        productCache[handle] = prod;
        return prod;
      })
      .catch(function () {
        if (savedMeta) {
          productCache[handle] = savedMeta;
          return savedMeta;
        }
        return null;
      });
  }

  // 7. Render Drawer Items
  function renderDrawer() {
    var container = document.getElementById('wishlistItemsContainer');
    var countLabel = document.getElementById('drawerWishlistCount');
    var footer = document.getElementById('wishlistFooter');
    if (!container) return;

    var handles = getWishlistHandles();
    if (countLabel) countLabel.textContent = '(' + handles.length + ')';

    if (handles.length === 0) {
      if (footer) footer.style.display = 'none';
      container.innerHTML = `
        <div class="wishlist-empty">
          <div class="wishlist-empty__icon">💖</div>
          <h4 class="wishlist-empty__title">Your Wishlist is Empty</h4>
          <p class="wishlist-empty__desc">Tap the ❤️ on any product to save it here!</p>
          <a href="/collections/all" class="btn-wishlist-explore">EXPLORE BAGS</a>
        </div>
      `;
      return;
    }

    container.innerHTML = `
      <div class="wishlist-drawer__loading">
        <div class="wishlist-spinner"></div>
      </div>
    `;

    Promise.all(handles.map(fetchProduct)).then(function (products) {
      var validProducts = products.filter(Boolean);

      if (validProducts.length === 0) {
        if (footer) footer.style.display = 'none';
        container.innerHTML = `
          <div class="wishlist-empty">
            <div class="wishlist-empty__icon">💖</div>
            <h4 class="wishlist-empty__title">Your Wishlist is Empty</h4>
            <p class="wishlist-empty__desc">Tap the ❤️ on any product to save it here!</p>
            <a href="/collections/all" class="btn-wishlist-explore">EXPLORE BAGS</a>
          </div>
        `;
        return;
      }

      if (footer) footer.style.display = 'block';

      container.innerHTML = validProducts.map(function (item) {
        var imgUrl = item.featured_image || (item.images && item.images[0]) || '';
        if (imgUrl.startsWith('//')) imgUrl = 'https:' + imgUrl;
        var formattedPrice = formatMoney(item.price);
        var itemUrl = item.url || ('/products/' + item.handle);

        return `
          <div class="wishlist-item" data-wishlist-handle="${item.handle}">
            <div class="wishlist-item__image">
              <a href="${itemUrl}"><img src="${imgUrl}" alt="${item.title}"></a>
            </div>
            <div class="wishlist-item__details">
              <a href="${itemUrl}" class="wishlist-item__title">${item.title}</a>
              <div class="wishlist-item__price">${formattedPrice}</div>
              <div class="wishlist-item__actions">
                <button type="button" class="btn-wishlist-remove" data-remove-handle="${item.handle}">
                  <span class="remove-icon">🗑️</span> Remove
                </button>
              </div>
            </div>
          </div>
        `;
      }).join('');
    });
  }

  // 7b. Render Dedicated Wishlist Page ([grid-wishlist])
  function renderWishlistPage() {
    var grid = document.querySelector('[grid-wishlist]');
    if (!grid) return;
    var section = document.getElementById('wishlist');
    var handles = getWishlistHandles();

    if (handles.length === 0) {
      grid.innerHTML = '';
      if (section) section.classList.remove('wishlist_exists');
      return;
    }
    if (section) section.classList.add('wishlist_exists');
    grid.innerHTML = '<div class="col-12 text-center py-5"><div class="wishlist-spinner"></div></div>';

    Promise.all(handles.map(fetchProduct)).then(function (products) {
      var validProducts = products.filter(Boolean);
      if (validProducts.length === 0) {
        grid.innerHTML = '';
        if (section) section.classList.remove('wishlist_exists');
        return;
      }

      grid.innerHTML = validProducts.map(function (item) {
        var imgUrl = item.featured_image || (item.images && item.images[0]) || '';
        if (imgUrl.startsWith('//')) imgUrl = 'https:' + imgUrl;
        var formattedPrice = formatMoney(item.price);
        var itemUrl = item.url || ('/products/' + item.handle);

        return `
          <div class="col mb-30" data-wishlist-handle="${item.handle}">
            <div class="yumi-product-card" style="border: 1px solid #E8E2DC; border-radius: 20px; overflow: hidden; background: #fff; display: flex; flex-direction: column; position: relative;">
              <div class="yumi-product-card__image-wrap" style="position: relative; aspect-ratio: 1/1; overflow: hidden; background: #FFF4ED;">
                <a href="${itemUrl}" style="position: absolute; inset: 0; z-index: 1;" aria-label="${item.title}"></a>
                <img src="${imgUrl}" alt="${item.title}" style="width: 100%; height: 100%; object-fit: cover;" loading="lazy">
                <button type="button" class="btn-wishlist-remove" data-remove-handle="${item.handle}" style="position: absolute; top: 12px; right: 12px; z-index: 5; width: 34px; height: 34px; border-radius: 50%; background: rgba(255,255,255,0.95); border: 1px solid #E8E2DC; cursor: pointer; display: flex; align-items: center; justify-content: center; font-size: 14px; color: #7A7067; box-shadow: 0 2px 8px rgba(0,0,0,0.08);" title="Remove from wishlist">
                  ✕
                </button>
              </div>
              <div class="yumi-product-card__info" style="padding: 16px; display: flex; flex-direction: column; flex: 1;">
                <a href="${itemUrl}" style="font-family: 'Nunito', sans-serif; font-size: 16px; font-weight: 700; color: #2D2A26; text-decoration: none; margin-bottom: 8px; line-height: 1.35;">${item.title}</a>
                <div style="font-family: 'Fredoka', sans-serif; font-size: 18px; font-weight: 700; color: #2D2A26; margin-bottom: 14px;">${formattedPrice}</div>
                <a href="${itemUrl}" class="yumi-btn-view-hamper" style="width: 100%; padding: 10px 14px; background: #0D8AAD; color: #fff !important; border-radius: 9999px; text-decoration: none; text-align: center; font-weight: 700; font-size: 12.5px; text-transform: uppercase; letter-spacing: 0.5px; display: inline-flex; align-items: center; justify-content: center; margin-top: auto; box-sizing: border-box;">View Product</a>
              </div>
            </div>
          </div>
        `;
      }).join('');
    });
  }

  // 8. Remove Item from Wishlist
  function removeWishlistHandle(handle) {
    var handles = getWishlistHandles();
    var idx = handles.indexOf(handle);
    if (idx !== -1) {
      handles.splice(idx, 1);
      setWishlistHandles(handles);
      try {
        localStorage.removeItem('shopify-wishlist-meta-' + handle);
      } catch (e) {}
      syncUI();
      renderDrawer();
      renderWishlistPage();
      showToast('Removed product from Wishlist');
    }
  }

  // 9. Toggle Item in Wishlist
  function toggleWishlistHandle(handle, title) {
    var handles = getWishlistHandles();
    var idx = handles.indexOf(handle);
    var added = false;
    if (idx === -1) {
      handles.push(handle);
      added = true;
      showToast('❤️ Saved to Wishlist!');
    } else {
      handles.splice(idx, 1);
      added = false;
      try {
        localStorage.removeItem('shopify-wishlist-meta-' + handle);
      } catch (e) {}
      showToast('Removed from Wishlist');
    }
    setWishlistHandles(handles);
    syncUI();
    var drawer = document.getElementById('wishlistDrawer');
    if (drawer && drawer.classList.contains('active')) {
      renderDrawer();
    }
    renderWishlistPage();
    return added;
  }

  // 10. Sync Badges & Heart Buttons across Page
  function syncUI() {
    var handles = getWishlistHandles();
    var count = handles.length;

    // Update all badge counts
    document.querySelectorAll('.wishlist__count, #drawerWishlistCount, .header__actions_btn_cart_num.wishlist__count').forEach(function (el) {
      el.textContent = count;
      if (el.id === 'drawerWishlistCount') el.textContent = '(' + count + ')';
    });

    // Update all heart buttons
    document.querySelectorAll('wishlist-item').forEach(function (wItem) {
      var btn = wItem.querySelector('button');
      if (!btn) return;
      var handle = btn.dataset.productHandle;
      if (handle) {
        if (handles.indexOf(handle) !== -1) {
          btn.classList.add('active');
        } else {
          btn.classList.remove('active');
        }
      }
    });

    // Update all product card heart buttons (.yumi-product-card__wishlist)
    document.querySelectorAll('.yumi-product-card__wishlist').forEach(function (btn) {
      var handle = btn.getAttribute('data-product-handle');
      if (!handle) {
        var card = btn.closest('.yumi-product-card');
        if (card) {
          var link = card.querySelector('a[href*="/products/"]');
          if (link) {
            var match = link.getAttribute('href').match(/\/products\/([^\/\?]+)/);
            if (match) handle = match[1];
          }
        }
      }
      if (handle) {
        var isSaved = handles.indexOf(handle) !== -1;
        btn.classList.toggle('is-active', isSaved);
        btn.classList.toggle('active', isSaved);
      }
    });

    // Update PDP Wishlist button
    var pdpWishlistBtns = document.querySelectorAll('#wishlistBtn, .yumi-wishlist-btn');
    pdpWishlistBtns.forEach(function (pdpBtn) {
      var pdpHandle = pdpBtn.getAttribute('data-product-handle');
      if (!pdpHandle) {
        var match = window.location.pathname.match(/\/products\/([^\/\?]+)/);
        if (match) pdpHandle = match[1];
      }
      var isSaved = pdpHandle && handles.indexOf(pdpHandle) !== -1;
      pdpBtn.classList.toggle('is-active', isSaved);
      pdpBtn.classList.toggle('active', isSaved);
      var textSpan = pdpBtn.querySelector('span');
      if (textSpan) {
        textSpan.textContent = isSaved ? 'Saved to Wishlist' : 'Add to Wishlist';
      }
      var svgHeart = pdpBtn.querySelector('svg path');
      if (svgHeart) {
        svgHeart.setAttribute('fill', isSaved ? '#E74C3C' : 'none');
        svgHeart.setAttribute('stroke', isSaved ? '#E74C3C' : 'currentColor');
      }
    });
  }

  // 11. Legacy WishlistProduct Custom Element (Ensures Theme Compatibility)
  class WishlistProduct extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', this.onAddWishlist.bind(this));
      this.onAddActiveClass();
      this.WishlistItemCounter();
    }

    WishlistItemCounter() {
      syncUI();
    }

    onAddActiveClass() {
      var btn = this.querySelector('button');
      if (btn) {
        var handle = btn.dataset.productHandle;
        var handles = getWishlistHandles();
        if (handle && handles.indexOf(handle) !== -1) {
          btn.classList.add('active');
        }
      }
    }

    onAddWishlist(e) {
      var btn = this.querySelector('button');
      if (!btn) return;
      var handle = btn.dataset.productHandle;
      if (!handle) return;

      e.preventDefault();
      e.stopPropagation();

      var isAdded = toggleWishlistHandle(handle);
      btn.classList.toggle('active', isAdded);
    }

    getWishlist() {
      return getWishlistHandles();
    }

    setWishlist(array) {
      setWishlistHandles(array);
      return array.join(DELIMITER);
    }

    updateWishlist(handle) {
      return toggleWishlistHandle(handle);
    }

    wishlistContains(handle) {
      return getWishlistHandles().indexOf(handle) !== -1;
    }
  }

  if (!customElements.get('wishlist-item')) {
    customElements.define('wishlist-item', WishlistProduct);
  }

  // 12. Global Click Delegation
  document.addEventListener('click', function (e) {
    // A) Intercept all wishlist links / header buttons -> Open Drawer
    var wishlistTrigger = e.target.closest('a[href*="/pages/wishlist"], .header__actions_btn--wishlist, [data-wishlist-open], #headerWishlistBtn');
    if (wishlistTrigger) {
      e.preventDefault();
      e.stopPropagation();
      openDrawer();
      return;
    }

    // B) Drawer Remove Button
    var removeBtn = e.target.closest('.btn-wishlist-remove');
    if (removeBtn) {
      e.preventDefault();
      e.stopPropagation();
      var handle = removeBtn.getAttribute('data-remove-handle');
      if (handle) removeWishlistHandle(handle);
      return;
    }

    // C) PDP Wishlist Button Click
    var pdpBtn = e.target.closest('#wishlistBtn, .yumi-wishlist-btn');
    if (pdpBtn) {
      e.preventDefault();
      e.stopPropagation();
      var handle = pdpBtn.getAttribute('data-product-handle');
      if (!handle) {
        var match = window.location.pathname.match(/\/products\/([^\/\?]+)/);
        if (match) handle = match[1];
      }
      if (handle) {
        toggleWishlistHandle(handle);
      }
      return;
    }

    // D) Product Card Wishlist Button Click (.yumi-product-card__wishlist)
    var cardWishlistBtn = e.target.closest('.yumi-product-card__wishlist');
    if (cardWishlistBtn) {
      e.preventDefault();
      e.stopPropagation();
      var handle = cardWishlistBtn.getAttribute('data-product-handle');
      var card = cardWishlistBtn.closest('.yumi-product-card');
      if (!handle && card) {
        var link = card.querySelector('a[href*="/products/"]');
        if (link) {
          var match = link.getAttribute('href').match(/\/products\/([^\/\?]+)/);
          if (match) handle = match[1];
        }
      }
      if (handle) {
        var title = cardWishlistBtn.getAttribute('data-product-title');
        var price = cardWishlistBtn.getAttribute('data-product-price');
        var image = cardWishlistBtn.getAttribute('data-product-image');
        var url = cardWishlistBtn.getAttribute('data-product-url');
        if (card) {
          if (!title) {
            var tEl = card.querySelector('.yumi-product-card__title, .card__heading, .product-title');
            if (tEl) title = tEl.textContent.trim();
          }
          if (!price) {
            var pEl = card.querySelector('.yumi-product-card__price-current, .price-item--regular, .price');
            if (pEl) price = pEl.textContent.trim();
          }
          if (!image) {
            var iEl = card.querySelector('.yumi-product-card__image, img');
            if (iEl) image = iEl.src;
          }
          if (!url) {
            var uEl = card.querySelector('a[href*="/products/"]');
            if (uEl) url = uEl.getAttribute('href');
          }
        }
        if (title || price || image) {
          saveProductMeta(handle, {
            handle: handle,
            title: title || handle,
            price: price || '',
            featured_image: image || '',
            url: url || ('/products/' + handle)
          });
        }
        var isAdded = toggleWishlistHandle(handle, title);
        cardWishlistBtn.classList.toggle('is-active', isAdded);
        cardWishlistBtn.classList.toggle('active', isAdded);
      }
      return;
    }
  });

  // Global helper fallback
  window.toggleWishlist = function(handleOrId, title, price, image, url) {
    if (!handleOrId) return;
    if (title || price || image) {
      saveProductMeta(handleOrId, {
        handle: handleOrId,
        title: title || handleOrId,
        price: price || '',
        featured_image: image || '',
        url: url || ('/products/' + handleOrId)
      });
    }
    return toggleWishlistHandle(handleOrId, title);
  };

  // 13. Public API
  window.yumiWishlist = {
    open: openDrawer,
    close: closeDrawer,
    toggle: toggleWishlistHandle,
    remove: removeWishlistHandle,
    saveMeta: saveProductMeta,
    sync: syncUI,
    get: getWishlistHandles,
    renderPage: renderWishlistPage
  };

  // 14. Initialize
  function init() {
    ensureDrawer();
    syncUI();
    if (document.querySelector('[grid-wishlist]')) {
      renderWishlistPage();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
